export const AppRouteURL = {
  // home
  HOME: "/",
  DASHBOARD: "home",
  PAGE_NOT_FOUND: "/404",
  COLLABORATE_WITH_US: "/collaborate-with-us",
  DOWNLOAD_CERTIFICATE: "/certificate",

  //search
  PRODUCT_SEARCH_PAGE: "/search",

  //list
  UPCOMING_EVENTS: "upcoming-events",
  EVENTS: "events",
  RECOMENDED_EVENTS: "recommended-videos",
  WEBIBAR_EVENTS: "events/webinars",
  WORKSHOP_EVENTS: "events/workshops",
  MASTERCLASS_EVENTS: "events/masterclasses",

  //subjects
  PRACTICE_AREA: "subjects",
  // mylist
  MY_LIBRARY: "my-list",
  // VIEW_ALL:":event_name",

  //dashboard & rating/player
  DASHBOARDDETAILS: ":event_id",
  ALL_REVIEWS: "/:event_type/",
  WRITE_REVIEW: "/:event_type/",
  EDIT_REVIEW: "/:event_type/",
  // VIDEOPLAYERPARENTDETAILS: "player/:event_id",
  // VIDEOPLAYERDETAILS: "player/:event_id/:session_id",

  //checkout
  CHECKOUT_PAYMENT: "/checkout/payment",
  CHECKOUT_INFORMATION: "/checkout/information",
  PROFILE_INFORMATION: "user/profile",
  PROFILE_MANAGE_ORDERS: "user/order",
  PROFILE_VIRTUAL_LIBRARY: "user/library",
  PROFILE_MANAGE_SUBSCRIPTIONS: "user/subscription",
  PROFILE_WISHLIST: "user/wishlist",
  PROFILE_WALLET: "user/wallet",
  LOGIN: "auth/login",
  LOGOUT: "auth/logout",
  REGISTER: "auth/register",
  THANK_YOU_PURCHASE: "/thank-you/",
  PAYMENT_FAILED: "/payment/failed",
  ORDER_DETAIL: "/payment/invoice",
  RETRY_PAYMENT: "/retryPayment",
};
